import type { ReactNode } from "react"

import { useIsPhone } from "@/lib/hooks/use-is-phone"
import { SettingsMenuScreen } from "./sidebar"

/** Synchronous phone check: one render at the wrong width redirects the phone away before the list shows. */
export const SettingsIndex = ({ desktop }: { desktop: ReactNode }) => {
	const isPhone = useIsPhone()

	return isPhone ? <SettingsMenuScreen /> : <>{desktop}</>
}
